/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import $ from "jquery";
import OkC from "shared/util/OkcApi";
import Context from "shared/util/Context";
import _str from "shared/util/_str";

//##############################
/* GENERIC PHOTO UTILITIES */
//##############################

window.PhotoUtil = {
	// Uploads a file that's in a photo upload form. All that is required of a
	// photo upload form is that it contain an input element with a name
	// attribute of 'file'.
	//
	// form	  (jQuery) - Element containing 'file' input.
	// template	(bool) - Specify the image template found in ajaxuploader.T
	// success (function) - Function to call if succesful. Passes albums array.
	// error   (function) - Function to call if there's an error.
	uploadFileForm(params) {
		if (!params.form) {
			return false;
		}

		let fileInput = params.form.find('input[name="file"]');

		if (!fileInput.length || !fileInput.val()) {
			return false;
		}

		if (window.FileReader) {
			params.file = fileInput.prop("files")[0];
			this.ajaxUpload(params);
		} else {
			this.iframeUpload(params);
		}
	},

	// Upload a file via AJAX.
	//
	// See uploadFileForm for most params.
	// file (file) - File that comes from a file input field value.
	ajaxUpload(params) {
		if (!params.file) {
			if (typeof params.error === "function") {
				params.error();
			}

			return false;
		}

		let data = new FormData();
		data.append("file", params.file);
		data.append("userid", Context.get("userid"));
		data.append("okc_api", 1);

		if (params.template) {
			data.append("img_template", params.template);
		}

		if (typeof OkPhotos !== "undefined" && OkPhotos !== null) {
			OkPhotos.showLoader();
		}

		OkC.legacy("/ajaxuploader", {
			type: "POST",
			data,
			cache: false,

			success: response => {
				if (response != null ? response.error : undefined) {
					this.logPhotoError(params.file, response);
				}
				return typeof params.success === "function"
					? params.success(response)
					: undefined;
			},

			error: response => {
				this.logPhotoError(params.file, response);
				return typeof params.error === "function"
					? params.error(response)
					: undefined;
			},
		});

		return true;
	},

	// Save the user's last photo error to a SOOKIE for feedback purposes.
	logPhotoError(file, response) {
		let log = {};

		if (file.size) {
			log.size = file.size;
		}

		if (file.type) {
			log.type = file.type;
		}

		if (response.error) {
			log.error = response.error;
		} else {
			log.error = "Unknown";
		}

		AjaxSookie.set(
			"last_image_error",
			log,
			86400 * 7,
			"d76b56892162119f6a64860bccfc21d62458a51a"
		);
	},

	// Upload a file via an iframe form submission.
	//
	// See uploadFileForm for most params.
	iframeUpload(params) {
		if (this.iframeUploading) {
			return;
		}

		this.iframeUploading = true;
		this.iframeSuccessCb = params.success;
		this.iframeErrorCb = params.error;

		// Insert iframe, point form at it
		this.uploadFrame = $(
			'<iframe name="upload_frame" height="0" width="0"></iframe>'
		);
		$("body").append(this.uploadFrame);

		// Create a dummy form with the values. Literally move the file input in.
		// We'll put it back later.
		this.frameForm = $(
			'<form action="/ajaxuploader" method="POST" enctype="multipart/form-data" target="upload_frame"></form>'
		);
		let filePlaceholder = $('<div id="iframe_upload_file_placeholder">');
		let fileInput = params.form.find('input[name="file"]');
		fileInput.after(filePlaceholder);
		this.frameForm.append(fileInput);
		this.frameForm.append(`\
<input type="hidden" name="userid" value="${Context.get("userid")}"/>
<input type="hidden" name="simple_ajax" value="1"/>
<input type="hidden" name="photoutil" value="1"/>\
`);

		if (params.template) {
			this.frameForm.append(
				`<input type="hidden" name="img_template" value="${params.template}"/>`
			);
		}
		$("body").append(this.frameForm);

		// Set a timeout since iframes don't have AJAX-like callbacks.
		this.iframeTimeout = setTimeout(() => {
			this.iframeUploading = false;
			this.uploadFrame.remove();
			this.frameForm.remove();

			typeof params.error === "function" ? params.error() : undefined;
		}, 30 * 1000);

		// Submit the form, which targets the iframe
		this.frameForm.submit();

		// Alright, time to put it back
		filePlaceholder.after(fileInput);
		filePlaceholder.remove();
	},

	// Callback for the iframe upload, just a standin for the callback passed
	// in iframeUpload.
	iframeUploadCallback(response) {
		this.iframeUploading = false;
		this.uploadFrame.remove();
		this.frameForm.remove();
		clearTimeout(this.iframeTimeout);

		if (response.error) {
			typeof this.iframeErrorCb === "function"
				? this.iframeErrorCb(response)
				: undefined;
		} else {
			typeof this.iframeSuccessCb === "function"
				? this.iframeSuccessCb(response)
				: undefined;
		}
	},

	// Upload URL based images
	//
	// url	   (string) - URL to upload
	// success (function) - Function to call if succesful.
	// error   (function) - Function to call if there's an error.
	uploadUrl(params) {
		if (!params.url) {
			if (typeof params.error === "function") {
				params.error();
			}

			return false;
		}

		let newUrl = params.url.replace(/https:\/\//, "");
		newUrl = newUrl.replace(
			/^.*\.(okcimg|okccdn)\.com/,
			"ip-0.prod.okcupid.com"
		);
		let data = {
			userid: Context.get("userid"),
			okc_api: 1,
			url: newUrl,
			upfile: newUrl,
		};

		return OkC.legacy("/ajaxuploader", {
			type: "POST",
			data,

			success: response => {
				return typeof params.success === "function"
					? params.success(response)
					: undefined;
			},

			error: response => {
				return typeof params.error === "function"
					? params.error(response)
					: undefined;
			},
		});
	},

	// Update a photo's details.
	//
	// picid	 (string) - ID of the picture. REQUIRED.
	// caption   (string) - Description of the photo
	// ordinal	  (int) - Photo's ordinal, position in the album.
	// crop	  (object) - Object with top, left, right, and bottom params.
	// success (function) - Function to call if succesful.
	// error   (function) - Function to call if there's an error.
	updatePhoto(params) {
		let data = { picid: params.picid };

		if (params.caption != null) {
			data.caption = params.caption;
		}

		if (params.ordinal != null) {
			data.ordinal = params.ordinal;
		}

		if (params.crop) {
			data.crop_info = {
				upper_left_x: params.crop.left,
				upper_left_y: params.crop.top,
				lower_right_x: params.crop.right,
				lower_right_y: params.crop.bottom,
			};
		}

		OkC.api("/profile/me/photos", {
			api: 1,
			type: "PUT",
			data: { photos: [data] },

			success: response => {
				if (
					response.updated_photos != null
						? response.updated_photos.length
						: undefined
				) {
					typeof params.success === "function"
						? params.success(response.updated_photos[0])
						: undefined;
				} else {
					typeof params.error === "function"
						? params.error()
						: undefined;
				}
			},

			error: () => {
				typeof params.error === "function" ? params.error() : undefined;
			},
		});
	},

	// Delete a photo by ID.
	//
	// picid	 (string) - ID of the picture. REQUIRED.
	// success (function) - Function to call if succesful.
	// error   (function) - Function to call if there's an error.
	deletePhoto(params) {
		if (!params.picid) {
			return;
		}

		OkC.api(`/profile/me/photos/${params.picid}`, {
			api: 1,
			type: "DELETE",

			success: response => {
				typeof params.success === "function"
					? params.success(response)
					: undefined;
			},

			error: () => {
				typeof params.error === "function" ? params.error() : undefined;
			},
		});
	},

	// Call this when you swap primary photos. Handles all replacement needed.
	swapPrimary(photo) {},

	/* ERRORS */

	// The E_ errors come from the backend.
	ERRORS: {
		TIMEOUT: "TIMEOUT",
		FILE_TYPE: "FILETYPE",
		NO_PHOTOS: "NOPHOTOS",
		CONNECTION: "CONNECTION",
		SOCIAL: "SOCIAL",
		UPLOAD_FAIL: "E_INPUT",
		TOO_SMALL: "E_FILE_TOO_SMALL",
		TOO_LARGE: "TOO_LARGE",
		FULL: "E_QUOTA",
		BAD_PHOTO: "E_BAD_IMAGE",
	},

	ERROR_INFO: {
		default: {
			text: _str("That doesn’t look right"),
			desc: _str("Something went wrong, try another photo."),
		},

		TIMEOUT: {
			text: _str("Connection timed out"),

			desc: _str(
				"Connection timed out. This sometimes happens with large photos, try reducing the size."
			),
		},

		FILETYPE: {
			text: _str("Homie don’t play that"),
			desc: _str("We only accept JPGs, PNGs, GIFs, or WEBPs."),
		},

		NOPHOTOS: {
			text: _str("No photos found"),
			desc: _str("There doesn’t seem to be anything here."),
		},

		CONNECTION: {
			text: _str("Connection to server lost"),
			desc: _str("We had trouble connecting. Try again in a bit."),
		},

		SOCIAL: {
			text: _str("Having some trouble here"),

			desc: _str(
				"We couldn’t connect to their service. Try again in a bit."
			),
		},

		TOO_LARGE: {
			text: _str("Whoa, that’s a biggun"),

			desc: _str(
				"That file is too large for us to handle. Try shrinking it."
			),
		},

		E_INPUT: {
			text: _str("Something went wrong"),
			desc: _str("Make sure your file is a valid image, and try again."),
		},

		E_FILE_TOO_SMALL: {
			text: _str("Choose a bigger photo"),
			desc: _str("Photos must be at least 400x400px."),
		},

		E_QUOTA: {
			text: _str("All filled up"),
			desc: _str("This album is full."),
		},

		E_BAD_IMAGE: {
			text: _str("That doesn’t look right"),
			desc: _str("There was a problem reading your photo, try another."),
		},

		E_EMPTY_FILE: {
			text: _str("That doesn’t look right"),
			desc: _str("There was a problem reading your photo, try another."),
		},

		E_INVALID_URL: {
			text: _str("We had trouble fetching your image"),

			desc: _str(
				"Please try downloading the image and uploading from your computer."
			),
		},
	},
};



// WEBPACK FOOTER //
// ./src/legacy/photoutil.js